export function getBusinessAccounts() {
    return `/hq/business-accounts`;
}
export function getBusinessAccountById(businessAccountId) {
    return `/hq/business-accounts/${businessAccountId}`;
}
export function getServicesByBusinessAccountHQ(businessAccountId) {
    return `/hq/business-accounts/${businessAccountId}/services`;
}
export function getSubscriptionsByBusinessAccountHQ(businessAccountId) {
    return `/hq/business-accounts/${businessAccountId}/subscriptions`;
}
export function getMembershipsByBusinessAccountHQ(businessAccountId) {
    return `/hq/business-accounts/${businessAccountId}/memberships`;
}
export function getSystemWaterwaysWithSubscribedServicesHQ() {
    return '/hq/system-waterways/subscribed-services';
}
export function lookupUserHQ(q) {
    return `/hq/users/lookup?q=${encodeURIComponent(q)}`;
}
export function getEditorsBySystemWaterwayHQ(systemWaterwayId) {
    return `/hq/system-waterways/${systemWaterwayId}/editors`;
}
export function createEditorForSystemWaterwayHQ(systemWaterwayId) {
    return `/hq/system-waterways/${systemWaterwayId}/editors`;
}
export function updateEditorScopeForSystemWaterwayHQ(systemWaterwayId, editorId) {
    return `/hq/system-waterways/${systemWaterwayId}/editors/${editorId}`;
}
export function deleteEditorForSystemWaterwayHQ(systemWaterwayId, editorId) {
    return `/hq/system-waterways/${systemWaterwayId}/editors/${editorId}`;
}
export function getAdminsBySystemWaterwayHQ(systemWaterwayId) {
    return `/hq/system-waterways/${systemWaterwayId}/admins`;
}
export function createAdminForSystemWaterwayHQ(systemWaterwayId) {
    return `/hq/system-waterways/${systemWaterwayId}/admins`;
}
export function updateAdminScopeForSystemWaterwayHQ(systemWaterwayId, adminId) {
    return `/hq/system-waterways/${systemWaterwayId}/admins/${adminId}`;
}
export function deleteAdminForSystemWaterwayHQ(systemWaterwayId, adminId) {
    return `/hq/system-waterways/${systemWaterwayId}/admins/${adminId}`;
}
export function getGuidesBySystemWaterwayHQ(systemWaterwayId) {
    return `/hq/system-waterways/${systemWaterwayId}/guides`;
}
export function createGuideForSystemWaterwayHQ(systemWaterwayId) {
    return `/hq/system-waterways/${systemWaterwayId}/guides`;
}
export function deleteGuideForSystemWaterwayHQ(systemWaterwayId, guideId) {
    return `/hq/system-waterways/${systemWaterwayId}/guides/${guideId}`;
}
export function getPlatformEditorsHQ() {
    return '/hq/system-waterway-access/editors';
}
export function createPlatformEditorHQ() {
    return '/hq/system-waterway-access/editors';
}
export function deletePlatformEditorHQ(editorId) {
    return `/hq/system-waterway-access/editors/${editorId}`;
}
export function getPlatformAdminsHQ() {
    return '/hq/system-waterway-access/admins';
}
export function createPlatformAdminHQ() {
    return '/hq/system-waterway-access/admins';
}
export function deletePlatformAdminHQ(adminId) {
    return `/hq/system-waterway-access/admins/${adminId}`;
}
export function getInternalInvoicesByBusinessAccount(businessAccountId) {
    return `/hq/business-accounts/${businessAccountId}/internal-invoices`;
}
export function getInternalVATRatesByBusinessAccount(businessAccountId) {
    return `/hq/business-accounts/${businessAccountId}/internal-vat-rates`;
}
export function createInternalInvoice(businessAccountId) {
    return `/hq/business-accounts/${businessAccountId}/internal-invoices`;
}
export function creditInternalInvoice(internalInvoiceId) {
    return `/hq/internal-invoices/${internalInvoiceId}/credit`;
}
export function getInternalInvoicePdfUrl(internalInvoiceId) {
    return `/hq/internal-invoices/${internalInvoiceId}/pdf_url`;
}
/** Cross-account internal invoice list, for the bank-claim export. */
export function getInternalInvoicesHQ() {
    return '/hq/internal-invoices';
}
export function getInternalProductsHQ() {
    return '/hq/internal-products';
}
export function createInternalProductHQ() {
    return '/hq/internal-products';
}
export function updateInternalProductHQ(internalProductId) {
    return `/hq/internal-products/${internalProductId}`;
}
export function deleteInternalProductHQ(internalProductId) {
    return `/hq/internal-products/${internalProductId}`;
}
export function createBusinessAccountHQ() {
    return `/hq/business-accounts`;
}
export function inviteBusinessUserHQ() {
    return '/hq/business-accounts/invitation';
}
export function createSubscriptionHQ(businessAccountId) {
    return `/hq/business-accounts/${businessAccountId}/subscriptions`;
}
export function updateSubscriptionPackageHQ(businessAccountId, subscriptionId) {
    return `/hq/business-accounts/${businessAccountId}/subscriptions/${subscriptionId}/package`;
}
export function inviteMembershipHQ(businessAccountId) {
    return `/hq/business-accounts/${businessAccountId}/memberships/invitations`;
}
export function updateMembershipRolesHQ(businessAccountId, membershipId) {
    return `/hq/business-accounts/${businessAccountId}/memberships/${membershipId}/roles`;
}
export function deleteMembershipHQ(businessAccountId, membershipId) {
    return `/hq/business-accounts/${businessAccountId}/memberships/${membershipId}`;
}
export function resetBusinessUserPasswordHQ(businessAccountId, businessUserId) {
    return `/hq/business-accounts/${businessAccountId}/users/${businessUserId}/password/reset`;
}
export function updateBusinessUserRequirePasswordChangeHQ(businessAccountId, businessUserId) {
    return `/hq/business-accounts/${businessAccountId}/users/${businessUserId}/require-password-change`;
}
export function refreshMembershipInvitationHQ(businessAccountId, membershipId) {
    return `/hq/business-accounts/${businessAccountId}/memberships/${membershipId}/invitations`;
}
// Sets the Adyen Cloud Device API key for POS terminals. Backend encrypts (encryptSecret)
// and returns only a masked representation; plaintext is never stored client-side or returned.
export function setAdyenTerminalApiKey(businessAccountId) {
    return `/hq/business-accounts/${businessAccountId}/adyen-terminal-api-key`;
}
export function getEmailBroadcastsHQ() {
    return '/hq/email-broadcasts';
}
export function getEmailBroadcastTemplatesHQ() {
    return '/hq/email-broadcasts/templates';
}
export function getEmailBroadcastRecipientsHQ(params) {
    const query = new URLSearchParams();
    if (params.all) {
        query.set('all', 'true');
    }
    else if (params.businessAccountIds?.length) {
        query.set('business_account_ids', params.businessAccountIds.join(','));
    }
    return `/hq/email-broadcasts/recipients?${query.toString()}`;
}
export function previewEmailBroadcastHQ() {
    return '/hq/email-broadcasts/preview';
}
export function testEmailBroadcastHQ() {
    return '/hq/email-broadcasts/test';
}
export function createEmailBroadcastHQ() {
    return '/hq/email-broadcasts';
}
export function getEmailBroadcastByIdHQ(emailBroadcastId) {
    return `/hq/email-broadcasts/${emailBroadcastId}`;
}
export function retryEmailBroadcastHQ(emailBroadcastId) {
    return `/hq/email-broadcasts/${emailBroadcastId}/retry`;
}
export function getFailedJobsHQ() {
    return '/hq/failed-jobs';
}
export function retryFailedJobHQ(queueName, jobId) {
    return `/hq/failed-jobs/${queueName}/${jobId}/retry`;
}
export function dismissFailedJobHQ(queueName, jobId) {
    return `/hq/failed-jobs/${queueName}/${jobId}`;
}
export function getHydroStationsHQ() {
    return '/hq/hydro/stations';
}
export function createHydroStationHQ() {
    return '/hq/hydro/stations';
}
export function updateHydroStationHQ(hydroStationId) {
    return `/hq/hydro/stations/${hydroStationId}`;
}
export function getHydroMeasurementTypesHQ() {
    return '/hq/hydro/measurement-types';
}
export function createHydroMeasurementTypeHQ() {
    return '/hq/hydro/measurement-types';
}
export function getWebhookEventsHQ(status) {
    return status ? `/hq/webhook-events?status=${status}` : '/hq/webhook-events';
}
export function reprocessWebhookEventHQ(eventId) {
    return `/hq/webhook-events/${eventId}/reprocess`;
}
// Hafró catch publishing
export function getHafroSeasonOverviewHQ(season) {
    return `/hq/hafro/seasons/${season}`;
}
export function getHafroAnalysisHQ(systemWaterwayId, season) {
    return `/hq/hafro/system-waterways/${systemWaterwayId}/seasons/${season}/analysis`;
}
export function publishHafroSeasonHQ(systemWaterwayId, season) {
    return `/hq/hafro/system-waterways/${systemWaterwayId}/seasons/${season}/publish`;
}
export function getHafroWaterwayTargetsHQ(systemWaterwayId) {
    return `/hq/hafro/system-waterways/${systemWaterwayId}/target`;
}
export function putHafroWaterwayTargetHQ(systemWaterwayId) {
    return `/hq/hafro/system-waterways/${systemWaterwayId}/target`;
}
export function putHafroBeatTargetHQ(systemWaterwayBeatId) {
    return `/hq/hafro/beats/${systemWaterwayBeatId}/target`;
}
export function searchHafroWatersHQ(name) {
    return `/hq/hafro/waters?name=${encodeURIComponent(name)}`;
}
export function getHafroWaterFishingAreasHQ(hafroWaterId) {
    return `/hq/hafro/waters/${hafroWaterId}/fishing-areas`;
}
export function createHafroWaterFishingAreaHQ(hafroWaterId) {
    return `/hq/hafro/waters/${hafroWaterId}/fishing-areas`;
}
